import { createContext } from "react";

export const ObjectiveContext = createContext({});
